const mobileApp = {
    en: {
      mobile_app_table_view: 'Showing {pageTotal} of {total}',
      mobile_app_dir: {
        mobile_app: 'Mobile App'
      },
      mobile_app_contact: {
        contacts: 'Contacts',
        contact_lists: 'Contact Lists',
        remove_contact_from_contact_lists: 'Remove contact from selected contact lists',
        contact: 'Contact',
        first_name: 'First Name',
        last_name: 'Last Name',
        projects: 'Projects',
        registered_devices_count: 'Registered Devices Count',
        email: 'Email',
        created_at: 'Created At',
        devices: 'Devices',
        existing_contact_lists: 'Existing Contact Lists',
        list_name: 'List Name',
        contacts_lists: 'Contact Lists',
        add_contact: 'Add Contact',
        add_contact_list_to_contact: 'Add contact list to contact',
        empty_contact_list_search: 'There are no contact lists to show. Consider changing your search criteria.',
        search_to_find_contact_lists: 'Search to find contact lists',
        device: {
          system_type: 'System Type',
          model_name: 'Model Name',
          device_type: 'Device Type',
          app_version: 'App Version',
          last_login_at: 'Last Login',
          created_at: 'Created At',
          last_sync_at: 'Last Sync'
        }
      },
      mobile_app_contact_list: {
        add_contact_list: 'Add Contact List',
        name: 'Name',
        client: 'Client',
        project: 'Project',
        projects: 'Projects',
        confirm_contact_list_remove: 'Are you sure you want to delete this contact list?',
        number_of_contacts: 'No. of Contacts',
        users: 'Contacts',
        create_contact_list: 'Create Contact List',
        update_contact_list: 'Update Contact List',
        add_contact_to_list_tootlip: 'Add contact to contact list',
        search_to_find_contacts: 'Search to find contacts',
        empty_contact_search: 'There are no contacts to show. consider changing your search criteria.',
        list_contacts: 'List of Contacts',
        remove_contacts_from_contact_list: 'Remove selected contacts from contact list',
        placeholders: {
          enter_list_name: 'Enter List Name',
          select_client: 'Select a Client',
          select_project: 'Select a Project',
        },
      },
      mobile_app_show_less: 'Show Less',
      mobile_app_show_more: 'Show More',
      mobile_app_na: 'N/A'
    }
}
  
module.exports.mobileApp = mobileApp;